export const SDK_VERSION = '7.26.0';
